import ja from 'date-fns/locale/ja'
import ReactDatepicker, { registerLocale } from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

registerLocale('ja', ja)

export const DatePicer = ReactDatepicker
